import { useCallback } from "react";

export const useCommentUtilsHook = () => {
  const getFileAssociatedComments = useCallback((comments, documentId) => {
    if (!comments) {
      return [];
    }

    if (!documentId) {
      return [];
    }

    // Filter comments that have the documentId in their documents array
    return comments.filter((comment) => {
      const loanDocumentIds = comment?.associations?.loanDocuments;
      // const loanDocumentIds = comment?.loanDocuments || comment?.documents;
      // Check if comment has a documents array and if it includes the documentId
      return (
        loanDocumentIds &&
        Array.isArray(loanDocumentIds) &&
        loanDocumentIds.includes(documentId)
      );
    });
  }, []);

  const getCommentsAssociatedWithBorrower = useCallback(
    (comments, borrowerId) => {
      if (!comments) {
        return [];
      }

      if (!borrowerId) {
        return [];
      }

      // Filter comments that have the borrowerId in their documents array
      return comments.filter((comment) => {
        const commentBorrowerIds = comment?.associations?.borrowers;
        // Check if comment has a documents array and if it includes the borrowerId
        return (
          commentBorrowerIds &&
          Array.isArray(commentBorrowerIds) &&
          commentBorrowerIds.includes(borrowerId)
        );
      });
    },
    []
  );

  const getCommentsAssociatedWithProperty = useCallback(
    (comments, propertyId) => {
      if (!comments) {
        return [];
      }

      if (!propertyId) {
        return [];
      }

      // Filter comments that have the borrowerId in their documents array
      return comments.filter((comment) => {
        const targetCommentIdList = comment?.associations?.subjectProperties;
        // Check if comment has a documents array and if it includes the borrowerId
        return (
          targetCommentIdList &&
          Array.isArray(targetCommentIdList) &&
          targetCommentIdList.includes(propertyId)
        );
      });
    },
    []
  );

  const getCommentsAssociatedWithTaskItemId = useCallback(
    (comments, taskItemId) => {
      if (!comments) {
        return [];
      }

      if (!taskItemId) {
        return [];
      }

      // Filter comments that have the borrowerId in their documents array
      return comments.filter((comment) => {
        const targetCommentIdList = comment?.associations?.tasks;
        // Check if comment has a documents array and if it includes the borrowerId
        return (
          targetCommentIdList &&
          Array.isArray(targetCommentIdList) &&
          targetCommentIdList.includes(taskItemId)
        );
      });
    },
    []
  );

  const getCommentsAssociatedWithItemId = useCallback(
    (comments, itemId, associationId) => {
      if (!comments) {
        return [];
      }

      if (!itemId) {
        return [];
      }

      // Filter comments that have the borrowerId in their documents array
      return comments.filter((comment) => {
        const targetCommentIdList = comment?.associations?.[associationId];
        // Check if comment has a documents array and if it includes the borrowerId
        return (
          targetCommentIdList &&
          Array.isArray(targetCommentIdList) &&
          targetCommentIdList.includes(itemId)
        );
      });
    },
    []
  );

  /**
   * SHARED
   */
  const getAssociatedIdsFromCommentList = useCallback(
    (comments, associationKeyName) => {
      if (!comments) {
        return [];
      }

      let list = [];
      comments?.forEach((comment) => {
        const ids = comment?.associations?.[associationKeyName] || [];
        list.push(...ids);
      });
      return [...new Set(list)];
    },
    []
  );

  return {
    getFileAssociatedComments,
    getCommentsAssociatedWithBorrower,
    getCommentsAssociatedWithProperty,
    getCommentsAssociatedWithTaskItemId,
    getCommentsAssociatedWithItemId,
    getAssociatedIdsFromCommentList,
  };
};
